import { observer } from "mobx-react-lite";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Header, Icon, Image, Segment } from "semantic-ui-react";
import LoadComponent from "../../../app/layout/LoadComponent";
import { RootStoreContext } from "../../../app/stores/rootStore";
import QuestionContent from "./QuestionContent";
import QuestionFilter from "./QuestionFilter";
import QuestionFooter from "./QuestionFooter";
import { BannerFormValues } from "../../../app/models/banner";
import { IUserPlan } from "../../../app/models/userPlan";

const Question: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadCategoriesOptions } = rootStore.categoryStore;
  const { loadRandomQuestion, question, loadingInitial, questionNotFound } =
    rootStore.questionStore;
  const { loadExaminingBoardsOptions } = rootStore.examiningBoardStore;
  const { openModal } = rootStore.modalStore;
  const { loadBannerByCode } = rootStore.bannerStore;
  const { currentPlan } = rootStore.userPlanStore;

  const [userPlan, setUserPlan] = useState<IUserPlan>();
  const [banner, setBanner] = useState(new BannerFormValues());
  const [popup1, setPopup1] = useState(new BannerFormValues());
  const [popup2, setPopup2] = useState(new BannerFormValues());
  const [popup1Loaded, setPopup1Loaded] = useState(false);
  const [popup2Loaded, setPopup2Loaded] = useState(false);

  useEffect(() => {
    currentPlan().then((result) => setUserPlan(result));
    loadCategoriesOptions(true);
    loadExaminingBoardsOptions();
    loadRandomQuestion();
    loadBannerByCode("QUESTION").then((banner) =>
      setBanner(new BannerFormValues(banner))
    );
  }, [
    currentPlan,
    loadCategoriesOptions,
    loadExaminingBoardsOptions,
    loadRandomQuestion,
    loadBannerByCode,
  ]);

  if (loadingInitial) return <LoadComponent content="Carregando questāo..." />;

  if (question) {
    if (question.todayQttAnsweredQuestions === 2 && !popup1Loaded)
      loadBannerByCode("POPUP1QUESTION")
        .then((banner) => {
          setPopup1(new BannerFormValues(banner));
          setPopup1Loaded(true);
        })
        .finally(() => {
          openModal(
            <Image src={popup1.url} href={popup1.redirectUrl} />,
            "small",
            true,
            true
          );
        });

    if (question.todayQttAnsweredQuestions === 4 && !popup2Loaded)
      loadBannerByCode("POPUP2QUESTION")
        .then((banner) => {
          setPopup2(new BannerFormValues(banner));
          setPopup2Loaded(true);
        })
        .finally(() => {
          openModal(
            <Image src={popup2.url} href={popup2.redirectUrl} />,
            "small",
            true,
            true
          );
        });
  }

  return (
    <Fragment>
      <QuestionFilter />
      {question ? (
        <Fragment>
          <QuestionContent />
          {!userPlan && banner && (
            <Fragment>
              <a
                href={banner.redirectUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image src={banner.url} />
              </a>
              <br />
            </Fragment>
          )}

          <QuestionFooter />
        </Fragment>
      ) : (
        <Segment placeholder style={{ paddingTop: "25px" }}>
          {questionNotFound && (
            <Fragment>
              <Header icon>
                <Icon name="warning circle" />
                Oops nenhuma questão encontrada!
              </Header>
              <Segment basic style={{ textAlign: "center" }}>
                <p style={{ fontSize: "13pt" }}>
                  Infelizmente nenhuma questão foi encontrada, favor tentar
                  novamente ou considere mudar o filtro acima para encontrar
                  outras questões.
                </p>
              </Segment>
            </Fragment>
          )}
          {!questionNotFound && (
            <Fragment>
              <Header icon>
                <Icon name="warning circle" />
                Oops
              </Header>
              <Segment basic style={{ textAlign: "center" }}>
                <p style={{ fontSize: "13pt" }}>
                  Você atingiu o limite diário de questões do seu plano.
                </p>
                <p style={{ fontSize: "13pt" }}>
                  Para ter acesso a essa funcionalidade e a milhares de questões
                  para o Exame do CFC, CNAI e CNPC clique no link abaixo para
                  assinar o CFC Questões
                </p>
                <br />
                <Button
                  content="Assinar agora"
                  positive
                  href="https://cfcacademy.com.br/cfc-questoes-pv-2/"
                />
              </Segment>
            </Fragment>
          )}
        </Segment>
      )}
    </Fragment>
  );
};

export default observer(Question);
